module.exports = __webpack_public_path__ + "img/set-followup.b38e818e.svg";